'use strict';

const initSimpleSlider = (slider) => {
    let isMouseDown = false;
    let startX;
    let scrollLeft;
    let pageX;
 
    slider.addEventListener("mousedown", event => {
        isMouseDown = true;
        slider.classList.add("active");

        pageX = event.pageX;
        startX = pageX - slider.offsetLeft;

        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
        isMouseDown = false;
        slider.classList.remove("active");
    });

    slider.addEventListener("mouseup", () => {
        isMouseDown = false;
        slider.classList.remove("active");
    });

    slider.addEventListener("mousemove", event => {
        if (isMouseDown) {
            event.preventDefault(); 
            const x = event.pageX - slider.offsetLeft;
            startX = pageX - slider.offsetLeft;
            const deviation = x - startX;
            slider.scrollLeft = scrollLeft - deviation;
        }
    });
}

export default initSimpleSlider;
          